import { GenericButton } from './GenericButton';
import { Button as ButtonType } from '@/schemas/sceneDataSchema';
import { Icon } from '@mui/material';

interface ComponentButtonProps {
  component: ButtonType;
  onClick?: () => void;
  form?: string;
  href?: string;
  type?: 'submit' | 'reset' | 'button';
  asComponent?: 'button' | 'a';
  loading?: boolean;
}

export const ComponentButton = ({
  component,
  onClick,
  type,
  form,
  href,
  asComponent = 'button',
  loading = false,
}: ComponentButtonProps) => {
  return (
    <GenericButton
      form={form}
      href={href}
      onClick={onClick}
      id={component.id}
      label={component.label}
      startIcon={component.start_icon && <Icon>{component.start_icon}</Icon>}
      endIcon={component.end_icon && <Icon>{component.end_icon}</Icon>}
      color={component.color}
      type={type}
      variant={component.variant}
      size={component.size}
      component={asComponent}
      loading={loading}
    />
  );
};
